import { Controller } from "@hotwired/stimulus"

// ⌘ + Entrée (Ctrl + Entrée hors Mac) envoie le formulaire depuis un champ, comme dans une messagerie.
// requestSubmit garde la validation du navigateur et l'envoi par Turbo.
//   <form data-controller="submit-shortcut"
//         data-action="keydown.meta+enter->submit-shortcut#submit keydown.ctrl+enter->submit-shortcut#submit">
export default class extends Controller<HTMLFormElement> {
  submit(event: KeyboardEvent) {
    event.preventDefault()
    this.element.requestSubmit()
  }
}
